const mutations = {
  SET (state, permissions) {
    state.permissions = permissions
  },

  SET_MY (state, permissions) {
    state.myPermissions = {}
    permissions.forEach(permission => {
      state.myPermissions[permission.name] = true
    })
  }
}

export default mutations
